import _flatten from 'lodash/flatten'

import { SilentCustomRequestError } from '@/helpers/requestErrors'

import { ERROR_MESSAGE_GENERIC, REQUEST_ERROR_MESSAGES, REQUEST_SUCCESS_MESSAGES } from '../constants'
import { receiveErrorAlerts, receiveSuccessAlert } from './alerts'

const API_DEFAULT_ERROR_MESSAGE = 'The request is invalid.'

export const START_REQUEST = 'START_REQUEST'
export const END_REQUEST = 'END_REQUEST'

export const startRequest = (data) => ({ type: START_REQUEST, data })

export const endRequest = (data) => ({ type: END_REQUEST, data })

export const handleRequestSuccess =
    ({ requestType }) =>
    (dispatch) => {
        if (!REQUEST_SUCCESS_MESSAGES[requestType]) return
        dispatch(receiveSuccessAlert(REQUEST_SUCCESS_MESSAGES[requestType]))
    }

export const handleRequestError =
    (error, { requestType = null, customMessage = null, hideAlert = false } = {}) =>
    (dispatch) => {
        if (error instanceof SilentCustomRequestError) {
            return
        }

        const errorMessage = []

        const serverErrorMessage = parseServerError(error)

        if (customMessage) {
            errorMessage.push(customMessage)
        } else if (requestType) {
            errorMessage.push(REQUEST_ERROR_MESSAGES[requestType] || ERROR_MESSAGE_GENERIC)
        } else {
            errorMessage.push(ERROR_MESSAGE_GENERIC)
        }

        if (!hideAlert) {
            dispatch(receiveErrorAlerts(errorMessage.join(' ')))

            if (serverErrorMessage) {
                dispatch(receiveErrorAlerts(serverErrorMessage.join(' ')))
            }
        }

        if (hideAlert && customMessage) {
            dispatch(receiveErrorAlerts(customMessage))
        }
    }

const parseServerError = (error) => {
    const data = error?.data

    const errorMessages = []

    if (data) {
        const status = error?.status
        const message = data?.message
        const modelState = data?.modelState

        if (message && message !== API_DEFAULT_ERROR_MESSAGE) {
            errorMessages.push(message)
        }

        if (modelState) {
            errorMessages.push(getModelStateMessages(modelState))
        }

        if (!message && !modelState) {
            errorMessages.push(JSON.stringify(data))
        }

        if (status) {
            errorMessages.push(`(${status})`)
        }
    }

    if (!errorMessages.length) return null

    return errorMessages
}

const getModelStateMessages = (modelState) => {
    const messages = [...new Set(_flatten(Object.values(modelState)))]

    return `${messages.join('. ')}.`
}
